/*
 * This file is part of glowingblue/orell-articles.
 *
 * Copyright (c) Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import LiteraryWorkState from '../states/LiteraryWorkState';
import type Mithril from 'mithril';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Placeholder from 'flarum/common/components/Placeholder';
import ArticleSlider from './ArticleSlider';
import ItemList from 'flarum/common/utils/ItemList';
import type LiteraryWork from '../models/LiteraryWork';

export default class LiteraryWorkPage extends Page {
	literaryWorkState = new LiteraryWorkState();
	work!: LiteraryWork;
	id!: string;
	bookId!: string;
	titleSet = false;

	oninit(vnode: Mithril.Vnode<any, this>) {
		super.oninit(vnode);
		this.id = vnode.attrs.id;
		this.bookId = vnode.attrs.aid;

		this.id = this.id.split('-')[0];
		this.literaryWorkState.id = this.id;
		this.literaryWorkState.refresh();
	}

	oncreate(vnode: Mithril.Vnode) {
		super.oncreate(vnode);

		this.setTitle();
	}

	setTitle() {
		const { literaryWork } = this.literaryWorkState;
		if (literaryWork) {
			const mainArticle = literaryWork.mainArticle();
			if (mainArticle) {
				const title = mainArticle.title();
				app.setTitle(title);
			}
		}
		app.setTitleCount(0);
	}

	view(): Mithril.Children {
		const { literaryWork, loading } = this.literaryWorkState;

		if (loading) {
			return <LoadingIndicator />;
		}

		if (!literaryWork) {
			return <Placeholder text={app.translator.trans('glowingblue-orell-articles.forum.work.placeholder')} />;
		}

		if (!this.titleSet) {
			this.setTitle();
			this.titleSet = true;
		}

		const articles = this.literaryWorkState.getArticles();

		return (
			<div className="LiteraryWorkPage">
				<div className="container">
					<ArticleSlider articles={articles} selectedBookId={this.bookId} />
					<span className="BCQuote closing"></span>
					<span className="BCQuote opening"></span>
				</div>
				<div className="container LiteraryWorkPage-reviews">{this.viewItems().toArray()}</div>
			</div>
		);
	}

	viewItems(): ItemList<Mithril.Children> {
		const items = new ItemList<Mithril.Children>();

		return items;
	}
}
